/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react';
import {connect} from 'react-redux'
import BanListItem from './BanListItem'

class ManageList extends React.Component {

    constructor() {
        super();
        this.state = {
            hasBtn: true
        }
    }

    componentDidMount() {
        let accountId = this.props.account.id;
        let id = this.props.liveroomSetting.liveroomInfo.liveroom.account_id;
        if (accountId !== id){
            this.setState({
                hasBtn: false
            })
        }
    }

    render() {
        const {liveroomSetting} = this.props;
        const list = liveroomSetting.liveroomManage.managers;

        return (
            <div className="ban-page-list manage-page-list">

                {list.length !== 0 &&
                list.map((item) => <BanListItem itemType={'manage'} content={item} key={item.id} hasBtn={this.state.hasBtn}/>)
                }

                {list.length === 0 &&
                <div className="manage-list-none">
                    <p>直播间管理员，可协助创建者</p>
                    <p>管理直播间点击下方按钮添加</p>
                </div>
                }
            </div>
        )
    }
}

export default connect(state => ({
    liveroomSetting: state.liveroomSetting,
    account: state.account
}))(ManageList)


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/ManageList.js